var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialFeatures(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_118_51717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1279 73.1905C26.6914 72.2564 28.0483 71.4206 29.4249 70.6143C41.8536 63.279 54.3118 56.0027 66.6913 48.5691C71.126 45.9044 75.2754 45.865 79.71 48.5297C93.004 56.4845 106.367 64.3115 119.7 72.1974C120.172 72.4727 120.634 72.7775 121.283 73.1905C120.713 73.5642 120.28 73.869 119.828 74.1246C104.784 82.4924 89.7297 90.8405 74.6953 99.2279C73.6628 99.7982 72.9057 99.867 71.8241 99.2672C56.8487 90.8896 41.8438 82.571 26.8487 74.2328C26.3374 73.9476 25.8359 73.6232 25.1279 73.2004V73.1905Z",
    fill: "url(#paint0_linear_118_51717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 78.6875C25.6195 78.9825 26.0619 79.1693 26.4848 79.4053C40.7522 87.4584 55.0098 95.5312 69.297 103.565C70.1721 104.056 70.5654 104.568 70.5556 105.62C70.5162 121.136 70.5359 136.642 70.5261 152.159C70.5261 152.522 70.4867 152.896 70.4474 153.496C67.8319 151.972 65.3933 150.556 62.9646 149.12C52.2566 142.817 41.5487 136.495 30.8309 130.212C26.9272 127.911 25 124.558 25 120.025C25.0197 106.741 25 93.4663 25 80.1821V78.6875Z",
    fill: "url(#paint1_linear_118_51717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.431 78.6777V80.4968C121.431 93.5548 121.391 106.613 121.45 119.661C121.47 124.479 119.493 127.96 115.354 130.389C102.699 137.783 90.0736 145.236 77.4384 152.66C77.0156 152.906 76.583 153.122 75.9832 153.447C75.9438 152.808 75.8947 152.336 75.8947 151.864C75.8947 136.524 75.8947 121.175 75.875 105.836C75.875 104.892 75.9537 104.223 76.9468 103.673C91.3814 95.5706 105.787 87.4191 120.201 79.2775C120.526 79.0907 120.87 78.9531 121.421 78.6777H121.431Z",
    fill: "url(#paint2_linear_118_51717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 164.282C134.105 164.282 125.62 164.252 117.144 164.301C115.207 164.311 113.584 163.79 112.04 162.61C106.583 158.451 101.077 154.36 95.5901 150.25C95.1476 149.926 94.7346 149.562 94.125 149.07C97.36 147.163 100.438 145.314 103.574 143.554C103.889 143.377 104.617 143.672 104.99 143.947C108.943 146.858 112.847 149.837 116.8 152.738C117.35 153.141 118.078 153.515 118.727 153.525C126.534 153.574 134.351 153.554 142.158 153.554C142.316 153.554 142.483 153.505 142.857 153.446C142.857 151.873 142.847 150.27 142.857 148.677C142.886 145.019 145.03 142.866 148.707 142.856C155.511 142.846 162.316 142.846 169.13 142.856C172.778 142.856 174.99 145.039 175 148.657C175.02 155.521 175.02 162.384 175 169.247C174.99 172.787 172.788 174.98 169.238 174.99C162.375 175.009 155.511 175.009 148.648 174.99C145.108 174.99 142.906 172.777 142.866 169.257C142.847 167.654 142.866 166.052 142.866 164.282H142.857ZM164.272 158.844C164.233 155.944 161.795 153.554 158.884 153.574C155.974 153.593 153.574 156.012 153.574 158.923C153.574 161.892 156.072 164.341 159.051 164.282C161.952 164.213 164.322 161.755 164.282 158.844H164.272Z",
    fill: "url(#paint3_linear_118_51717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1348 50.8604C96.0227 49.4346 97.7041 48.1662 99.3855 46.8978C103.623 43.7218 107.881 40.5654 112.08 37.3501C113.564 36.2095 115.138 35.6785 117.026 35.6982C125.551 35.7473 134.076 35.7178 142.856 35.7178C142.856 34.0561 142.856 32.4632 142.856 30.8702C142.876 27.2026 145.02 25.0197 148.658 25.0099C155.521 24.9902 162.375 24.9902 169.238 25.0099C172.768 25.0099 174.98 27.2223 175 30.7522C175.02 37.6647 175.02 44.5772 175 51.4995C174.99 54.9312 172.758 57.1338 169.317 57.1436C162.404 57.1633 155.492 57.1633 148.569 57.1436C145.069 57.1338 142.896 54.8919 142.866 51.3422C142.857 49.7886 142.866 48.235 142.866 46.5143C142.257 46.4848 141.726 46.4356 141.185 46.4356C133.879 46.4356 126.573 46.4061 119.268 46.475C118.402 46.475 117.419 46.8388 116.711 47.3501C112.876 50.1229 109.081 52.9745 105.334 55.8653C104.469 56.534 103.84 56.6913 102.847 56.062C100.064 54.3117 97.2124 52.6893 94.1348 50.8604ZM164.272 41.0571C164.272 38.1465 161.854 35.7375 158.953 35.7178C156.033 35.6982 153.614 38.0777 153.574 40.9981C153.535 43.9676 156.003 46.4553 158.982 46.4258C161.883 46.3963 164.282 43.9676 164.282 41.0571H164.272Z",
    fill: "url(#paint4_linear_118_51717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.856 105.393H126.907V94.6658H142.856C142.856 92.827 142.837 91.1751 142.856 89.5134C142.906 86.18 145.098 83.9578 148.441 83.9381C155.413 83.9086 162.384 83.9086 169.356 83.9381C172.768 83.948 174.98 86.1899 174.99 89.6314C175.01 96.5438 175.01 103.456 174.99 110.379C174.98 113.83 172.778 116.052 169.356 116.072C162.384 116.101 155.413 116.101 148.441 116.072C145.128 116.062 142.906 113.8 142.856 110.487C142.837 108.874 142.856 107.252 142.856 105.403V105.393ZM164.272 99.9853C164.272 97.0748 161.853 94.6658 158.953 94.6461C156.032 94.6264 153.613 97.006 153.574 99.9263C153.535 102.896 156.003 105.384 158.982 105.354C161.883 105.325 164.282 102.896 164.282 99.9853H164.272Z",
    fill: "url(#paint5_linear_118_51717)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_118_51717",
    x1: 73.2056,
    y1: 46.5508,
    x2: 73.2056,
    y2: 99.6873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_118_51717",
    x1: 47.7779,
    y1: 78.6875,
    x2: 47.7779,
    y2: 153.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_118_51717",
    x1: 98.6627,
    y1: 78.6777,
    x2: 98.6627,
    y2: 153.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_118_51717",
    x1: 134.57,
    y1: 142.849,
    x2: 134.57,
    y2: 175.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_118_51717",
    x1: 134.575,
    y1: 24.9951,
    x2: 134.575,
    y2: 57.1583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_118_51717",
    x1: 150.956,
    y1: 83.916,
    x2: 150.956,
    y2: 116.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_51717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFeatures);
export default __webpack_public_path__ + "static/media/Social_Features.9fcc10b3b2514d7c368735bc5ff2fdf2.svg";
export { ForwardRef as ReactComponent };